import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconArrowRightToBracketSharp = ({
  size = 24,
  ...props
}: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.114 18.227h4.667v-12h-4.667v-2h6.667v16h-6.667v-2ZM8.81 16.895l.707-.707 2.957-2.96H3.78v-2h8.7L9.52 8.267l-.708-.707 1.414-1.415.707.707 4.667 4.662.707.707-.706.707-4.667 4.672-.707.708-1.415-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconArrowRightToBracketSharp);
export default Memo;
